import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AiAssistantMessage } from "../../../components/app/provider/ai-assistant/types";

interface AiAssistantState {
  isOpen: boolean;
  isExpanded: boolean;
  messages: AiAssistantMessage[];
  isLoading: boolean;
  showHistory: boolean;
}

const initialState: AiAssistantState = {
  isOpen: false,
  isExpanded: false,
  messages: [],
  isLoading: false,
  showHistory: true,
};

const aiAssistantSlice = createSlice({
  name: "aiAssistant",
  initialState,
  reducers: {
    openChat: (state) => {
      state.isOpen = true;
    },
    closeChat: (state) => {
      state.isOpen = false;
      state.isExpanded = false;
    },
    toggleExpand: (state) => {
      state.isExpanded = !state.isExpanded;
    },
    toggleHistory: (state) => {
      state.showHistory = !state.showHistory;
    },
    addMessage: (state, action: PayloadAction<AiAssistantMessage>) => {
      state.messages.push(action.payload);
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setMessages: (state, action: PayloadAction<AiAssistantMessage[]>) => {
      state.messages = action.payload;
    },
    clearMessages: (state) => {
      state.messages = [];
    },
  },
});

export const {
  openChat,
  closeChat,
  toggleExpand,
  toggleHistory,
  addMessage,
  setMessages,
  setLoading,
  clearMessages,
} = aiAssistantSlice.actions;

export default aiAssistantSlice.reducer;
